// extracted by mini-css-extract-plugin
export default {"parkingSpaces":"styles_parkingSpaces__jF4p5","holder":"styles_holder__8mRhm","count":"styles_count__OP3cM","addWrapper":"styles_addWrapper__zmHH3"};